module.exports = __webpack_public_path__ + "images/home/boussole.4191066b.svg";